module.exports = __webpack_public_path__ + "images/emoji/bookmark_tabs.cb4986f7f2ab613d0b2e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bookmark_tabs.png
// module id = zPGX
// module chunks = 13